import { Component, OnInit, Output, EventEmitter, ChangeDetectorRef, Injector } from '@angular/core';
import { BaseControlComponent } from '../base-control/base-control.component';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';

/**
 * Component for entering a currency code via text input.
 * Extends BaseControlComponent for common form control functionality.
 */
@Component({
	selector: 'app-currency-select',
	templateUrl: './currency-select.component.html',
	styleUrls: ['./currency-select.component.scss'],
	providers: [MessageService]
})
export class CurrencySelectComponent extends BaseControlComponent implements OnInit {

	/**
	 * Emits the entered currency code (e.g., 'ILS', 'USD') when the input changes.
	 * @type {EventEmitter<string | null>}
	 */
	@Output() currencyChange = new EventEmitter<string | null>();

	/**
	 * Injects required services and passes dependencies to the base class.
	 * @param {Injector} injector - Injector for dependency injection.
	 * @param {TranslateService} translate - Service for handling translations.
	 * @param {ChangeDetectorRef} cdr - Service for triggering change detection.
	 * @param {MessageService} messageService - Service for displaying messages (toasts).
	 */
	constructor(
		protected override injector: Injector,
		protected override translate: TranslateService,
		protected override cdr: ChangeDetectorRef,
		protected override messageService: MessageService
	) {
		super(injector, translate, cdr, messageService);
	}

	/**
	 * Initializes the component by calling the base class ngOnInit
	 * and subscribing to parent control changes if needed.
	 * @override
	 */
	override ngOnInit(): void {
		super.ngOnInit();
		if (this.control) {
			if (this.control.value === null) {
this.control.setValue('ILS', { emitEvent: false });
				this.writeValue('ILS');
			}
			this.parentValueSub = this.control.valueChanges.subscribe(value => {
if (value === null) {
					this.control?.setValue('ILS', { emitEvent: false });
					this.writeValue('ILS');
				} else {
					this.writeValue(value);
				}
			});
		} else if (this.debug) {
			console.warn(`[DEBUG/CurrencySelect] Control not found for ${this.controlName}`);
		}
	}

	/**
	 * Handles changes in the currency text input.
	 * Emits the entered currency code (uppercased) and marks the control as interacted.
	 * @param {Event} event - The input event from the text field.
	 */
	onCurrencyInputChange(event: Event): void {
		const inputElement = event.target as HTMLInputElement;
		const enteredCode = inputElement.value ? inputElement.value.toUpperCase() : null;
		this._value = enteredCode;
		this.propagateChange(enteredCode);
		inputElement.value = enteredCode || '';
		this.currencyChange.emit(enteredCode);
		this.markAsInteracted();
	}
}